import { Carousel } from '../Carousel';

export type CardItem = {
  title: string;
  description: string | null;
  link: string;
  image: string[];
  alt: string | null;
  source: string | null;
};

export type CardItemProps = {
  item: CardItem;
  className?: string;
};

export function CardItem({ item, className }: CardItemProps) {
  const { title, description, link, source, image, alt } = item;

  return (
    <div className={`col-12 col-md-6 col-lg-3 ${className || ''}`}>
      <div className="post-entry" data-aos="fade-up" data-aos-delay="100">
        <a href={link} className="thumb d-block">
          <Carousel images={image} alt={alt} title={title} />
          <div className="post-content">
            <p className="card-item-title">{title}</p>
            {description && (
              <p className="card-item-description">{description}</p>
            )}
            {source && (
              <p className="card-item-font">
                <strong>Fonte:</strong> {source}
              </p>
            )}
          </div>
        </a>
      </div>
    </div>
  );
}
